<template>
    <ion-page>
        <CabeceraComponentBack :pdv="$route.meta.pdv" :isIOS="$route.meta.isIOS" titulo="Impresion etiquetas Ubicacion"
            color="primary" />

        <ion-content class="ion-padding ion-margin mipag">
            <ion-row>
                <ion-col id="selector-etiquetas-app">
                    <!-- Componente reutilizable de selección de ubicación -->
                    <TablaUbicacion
                        :zonaInit="zona"
                        :pasilloInit="pasillo"
                        :e0Init="e0"
                        :e1Init="e1"
                        :a0Init="a0"
                        :a1Init="a1"
                        :p0Init="p0"
                        :p1Init="p1"
                        @change="onTablaChange"
                    />
                </ion-col>
            </ion-row>
            <ion-row class="ion-justify-content-end ion-align-items-end ion-padding ion-margin">
                <ion-button class="final" expand="block" fill="solid" size="large" @click="generar()"
                    :disabled="e1 == undefined || a1 == undefined || isOnline == false || !$pdv">
                    Imprimir
                </ion-button>
            </ion-row>
        </ion-content>



    </ion-page>
</template>

<script>


import CabeceraComponentBack from '@/components/CabeceraComponentBack'
import { defineComponent } from 'vue';
import { openToast } from '@/utilities/services/alert-utilities';
import { isOnline } from '@/utilities/global_functions'
import TablaUbicacion from '@/components/ubicaciones/TablaUbicacion.vue'
export default defineComponent({
    name: "ImprimirEtiquetaUbicacionPage",
    components: { CabeceraComponentBack, TablaUbicacion },
    data() {
        return {
            isOnline,
            zona: 'ZOA',
            pasillo: 0,
            e0: 0,
            e1: undefined,
            a0: 0,
            a1: undefined,
            p0: undefined,
            p1: undefined,

        }
    },
    methods: {
        // Sincroniza el estado de la página con el componente TablaUbicacion
        onTablaChange(payload) {
            // Actualizamos los mismos campos usados por el flujo original
            this.zona = payload.zona
            this.pasillo = payload.pasillo
            this.e0 = payload.e0
            this.e1 = payload.e1
            this.a0 = payload.a0
            this.a1 = payload.a1
            this.p0 = payload.p0
            this.p1 = payload.p1
        },
        // Generate cartesian product of given iterables:
        * cartesian(head, ...tail) {
            let remainder = tail.length ? this.cartesian(...tail) : [[]];
            for (let r of remainder) for (let h of head) yield [h, ...r];
        },
        componer(a) {
            const resu = a.length == 3
                ? `${a[0]} ${String(a[1]).padStart(2, '0')} ${String(a[2]).padStart(2, '0')}`
                : `${a[0]} ${String(a[1]).padStart(2, '0')} ${String(a[2]).padStart(2, '0')} ${String(a[3]).padStart(2, '0')}`
            return (resu)
        },
        async generar() {
            await openToast('Lanzando impresiones...', `Lanzando impresiones, te redirigiremos a la pagina seleccion de ubicacion para que continues`, 2500)
            let self = this;
            const pasillo = ('0' + this.pasillo.toString()).slice(-2)
            let zona = [`${this.zona}${pasillo}`]
            let estantes = [...Array(51).keys()].filter(v => v >= this.e0 && v <= this.e1)
            let alturas = [...Array(51).keys()].filter(v => v >= this.a0 && v <= this.a1)
            window.miconsola(this.p0, !this.p0)
            let posiciones = (this.p0 == undefined) ? undefined : [...Array(26).keys()].filter(v => v >= this.p0 && v <= this.p1)
            window.miconsola(posiciones, this.p0, this.p1)
            let resu
            if (posiciones && posiciones.length > 0) {
                resu = [...this.cartesian(zona, estantes, alturas, posiciones)].map(x => this.componer(x))
            }
            else {
                resu = [...this.cartesian(zona, estantes, alturas)].map(x => this.componer(x))

            }
            window.miconsola(resu)

            resu.forEach(async (ubi) => {
                try {
                    await self.$http.post(`/etiqueta/ubicacion/${self.$pdv}`, { ubi })
                }
                catch (ex) {
                    console.log(ex)
                    window.miconsola('Error : ', ubi)
                }
            })
            self.$router.replace('/ubicar')
        }
    }

})
</script>

<style scoped>
ion-content {
    max-width: 700px !important;
}

ion-button.final {
    float: right !important;
}

</style>
